import { loadFacebookSDK, hasFacebookSession, clearFacebookSession } from '../helpers/facebook-sdk'

export function afterRegistration ({ Vue, isServer }) {
  if (isServer) return

  Vue.prototype.$bus.$on('user-after-logout', () => {
    if (!hasFacebookSession()) return
    clearFacebookSession()

    loadFacebookSDK()
      .then(FB => new Promise(resolve => {
        FB.getLoginStatus(response => {
          if (response && response.status === 'connected') FB.logout(() => resolve())
          else resolve()
        })
      }))
      .catch(error => console.error('Could not revoke the Facebook session on logout: ', error))
  })
}
